import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        wrapper: {
            '&&': {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        root: {
            minHeight: 300,
            '&:not(:first-of-type)': {
                marginTop: theme.spacing(2),
            },
            ':not(:last-child)': {
                marginBottom: theme.spacing(2),
            },
        },
        title: {
            '&&': {
                paddingLeft: theme.spacing(2),
            },
        },
    }
})

export default useStyles
